import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import Icon from 'JS/components/Icon.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import ReverseOrder from 'JS/components/ReverseOrder';
import { AutomotiveSchedulerStep } from '../../types/session';
import { computed, PropType } from 'vue';
import { getNextStep, getPreviousStep, getStepInfo } from '../../utils/steps';
import { useBreakpoints } from 'JS/composables/breakpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'StepControls',
  props: {
	step: {
		type: Number as PropType<AutomotiveSchedulerStep>,
		required: true,
	},
	canContinue: Boolean,
	screenReaderText: String,
},
  emits: ["previous"],
  setup(__props, { emit }: { emit: ({
	(e: 'previous'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const { isMobile } = useBreakpoints();

const nextStep = computed(() => getStepInfo(getNextStep(props.step)));
const previousStep = computed(() => getStepInfo(getPreviousStep(props.step)));

return { __sfc: true,props, emit, isMobile, nextStep, previousStep, BButton, Icon, LinkButton, ReverseOrder }
}

})